import axios from 'axios';

export function postDataAction(url, parent, types, body, el) {
  return (dispatch) => {
    if (url) {
      if(el) {
        let form = el.closest("[data-form]");
        let formErrors = form.querySelector(".error-message");
        let req = form.querySelectorAll("[data-required][value='']");
        let nullSelect = form.querySelectorAll(".select__placeholder");
        let requiredNullSelect = [];
        nullSelect.forEach(element => {
          if (element.closest('.dropdown_select[data-required]')) requiredNullSelect.push(element)
        });
        let dateinput = form.querySelectorAll("[type='date'][required][value='']");

        if (formErrors) {
          formErrors.scrollIntoView({block: "center", behavior: "smooth"});
          return false;
        }
        if (req.length) {
          req.forEach(function(e) {
            e.scrollIntoView({block: "center", behavior: "smooth"});
            e.className += " invalid-input";
            let errorMessage = "<span class='error-message'>Обязательное поле</span>";
            e.nextSibling.innerHTML = errorMessage;
          });
          return false
        }
        /* SELECT VALIDATION */
        if (requiredNullSelect.length > 0) {
          let firstSelect = requiredNullSelect[0];
          firstSelect.scrollIntoView({block: "center", behavior: "smooth"});
          requiredNullSelect.forEach(function(e) {
            let select = e.closest("[class*='dropdown_select']");
            select.className += " invalid-select";
            let errorMessage = "<span class='error-message'>Обязательное поле</span>";
            select.nextSibling.innerHTML = errorMessage;
          });
          return false;
        }
        /* DATEPICKER VALIDATION */
        if (dateinput.length) {
          dateinput.forEach(function(e) {
            let datepicker = e.parentNode.parentNode;
            datepicker.className += " invalid-input";
            let errorMessage = document.createElement('span');
            errorMessage.innerHTML = "Обязательное поле";
            errorMessage.className += " error-message";
            datepicker.parentNode.appendChild(errorMessage)
          });
          return false
        }
      }

      let preloader = document.getElementById("preloader");
      preloader.style.display = "block";

      axios.post(url, body)
        .then((response) => {
          if (response.data.result.status === 'AUTH_FAILED') {
            window.location.href = process.env.REACT_APP_ELF_URL;
          }
          return response.data;
        })
        .then((items) => {
          dispatch({type: types, items})
          preloader.style.display = "none";
        })
        .catch(error => {
          window.location=process.env.PUBLIC_URL + "/error";
        })

    }
    else {
      dispatch({type: types, url})
    }
  };
}